import { useQuery } from '@tanstack/react-query';
import { fetchPeriodSummary } from '../api/attendanceApi';
import { attendanceKeys } from './attendanceKeys';

/**
 * 고른 기간의 본인 합계 — 버그 제보 #119.
 * 두 날짜가 **모두** 있을 때만 조회한다. 한쪽만 고른 상태는 기간이 열려 있는 것이라
 * 그 합계가 사용자가 고른 범위를 뜻하지 않는다.
 */
export function usePeriodSummary(startDate: string | undefined, endDate: string | undefined) {
  return useQuery({
    queryKey: attendanceKeys.periodSummary(startDate, endDate),
    queryFn: () => fetchPeriodSummary(startDate as string, endDate as string),
    enabled: !!startDate && !!endDate,
    staleTime: 30_000,
  });
}
